import type { CreateReturnLabelInput } from 'Portal/__generated__/globalTypes'

import type { PortalReturnLabelModalFormSchema } from './PortalReturnLabelModal.types'

export const portalReturnLabelFormToInput = (
  data: PortalReturnLabelModalFormSchema,
  ids: {
    employeeId: string
    organisationId: string
    returnCaseIds: string[]
  },
): CreateReturnLabelInput => ({
  employeeId: ids.employeeId,
  organisationId: ids.organisationId,
  returnCaseIds: ids.returnCaseIds,
  senderAddress: {
    city: data.city,
    countryCode: data.country?.value || '',
    fullName: data.fullName,
    postalCode: data.zipcode,
    street: data.street,
    streetNumber: data.streetNumber,
  },
})
